import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import useValidation from '../../hooks/useValdation';
import service from '../../services/service';
import InputField from '../common/Input';
import Modal from '../common/Modal';

type Props = {
  onRequestClose: () => void;
  openThankModal: () => void;
};

const ContactUs = ({ onRequestClose: closeModal, openThankModal }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const validation = useValidation();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = async (data: any) => {
    setIsLoading(true);
    await service
      .sendHubSpot('contact');
    await service
      .contactForm(data)
      .then(() => {
        closeModal();
        openThankModal();
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <Modal onRequestClose={() => !isLoading && closeModal()}>
      <div id="contactUs">
        <div className="modal-body" style={{ maxWidth: 674 }}>
          <div className="modal-header">
            <p className="modal-title">Contact us</p>
            <button
              onClick={closeModal}
              className="modal-close"
              disabled={isLoading}
            >
              &nbsp;
            </button>
          </div>
          <div className="modal-content">
            <form className="modal-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-form_columns">
                <InputField
                  errors={errors}
                  type="text"
                  ref={register('firstName', validation.required) as any}
                  name="firstName"
                  placeholder="First name*"
                />
                <InputField
                  errors={errors}
                  type="text"
                  ref={register('lastName', validation.required) as any}
                  name="lastName"
                  placeholder="Last name*"
                />
                <InputField
                  errors={errors}
                  type="text"
                  ref={register('email', validation.email) as any}
                  name="email"
                  placeholder="Email*"
                />
                <InputField
                  errors={errors}
                  type="text"
                  ref={register('phone', validation.phone) as any}
                  name="phone"
                  placeholder="Phone number"
                />
              </div>
              <div className={`form-item ${errors.message ? 'error' : ''}`}>
                <textarea
                  placeholder="Message"
                  {...register('message', validation.message)}
                ></textarea>
                {errors.message && (
                  <p className="error-text">{errors.message.message}</p>
                )}
              </div>
              <div className="form-radio_row">
                <div className="form-item form-checkbox">
                  <input
                    type="checkbox"
                    id="radio1"
                    hidden
                    {...register('callMeBack')}
                  />
                  <label htmlFor="radio1">Call me back</label>
                </div>
                <div className="form-item form-checkbox">
                  <input
                    type="checkbox"
                    id="radio2"
                    hidden
                    {...register('emailMeBack')}
                  />
                  <label htmlFor="radio2">Email me back</label>
                </div>
              </div>
              <div
                className={`form-item form-checkbox ${
                  errors.tos ? 'error' : ''
                }`}
              >
                <input
                  type="checkbox"
                  hidden
                  id="checkbox"
                  {...register('tos', validation.required)}
                />
                <label htmlFor="checkbox">
                  I have read and accept the privacy policy of this site
                </label>
              </div>
              <button type="submit" className="btn" disabled={isLoading}>
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ContactUs;
